var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"user-guide-third-step"},[_c('image_upload',{attrs:{"images":_vm.data.product_images || [],"title":_vm.data.product_title || 'product_image'},on:{"updating":updated_images => _vm.$emit('update_value', updated_images, 'product_images')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }